module.exports = __webpack_public_path__ + "static/img/guan_ds.83f638d5.png";